import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useWatch } from 'react-hook-form';

const dataProviderName = 'administrations/commissioninvoice';
const model = 'administrations/commissioninvoice';
const modelExposedName = 'commissioninvoice';
const wizardAction = 'generate';

const Generate = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, existingModules } = useContext(AppContext);

    const modelName = existingModules.modelName

    // DATA PROVIDER
    const { doAction, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    const detailConfig = {
        "tabs": [
            {
                "name": "generateparams",
                "fieldsets": [
                    {
                        "name": "filters",
                        "fields": {
                            "month": {
                                "type": "select",
                                "label": "month",
                                "className": "col-6",
                                "required": true,
                                "options": [
                                    { label: t('January'), value: 1 },
                                    { label: t('February'), value: 2 },
                                    { label: t('March'), value: 3 },
                                    { label: t('April'), value: 4 },
                                    { label: t('May'), value: 5 },
                                    { label: t('June'), value: 6 },
                                    { label: t('July'), value: 7 },
                                    { label: t('August'), value: 8 },
                                    { label: t('September'), value: 9 },
                                    { label: t('October'), value: 10 },
                                    { label: t('November'), value: 11 },
                                    { label: t('December'), value: 12 }
                                ]
                            },
                            "year": {
                                "type": "select",
                                "label": "year",
                                "className": "col-6",
                                "required": true,
                                "options": [
                                    { label: 2019, value: 2019 },
                                    { label: 2020, value: 2020 },
                                    { label: 2021, value: 2021 },
                                    { label: 2022, value: 2022 },
                                    { label: 2023, value: 2023 },
                                    { label: 2024, value: 2024 },
                                    { label: 2025, value: 2025 },
                                    { label: 2026, value: 2026 },
                                    { label: 2027, value: 2027 },
                                    { label: 2028, value: 2028 },
                                    { label: 2029, value: 2029 },
                                    { label: 2030, value: 2030 }
                                ]
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    };


    return (
        <>
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    month: new Date().getMonth() + 1,
                    year: new Date().getFullYear()
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                title={t('Generate Commission Invoices')}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t('Generate monthly commission invoices')}
                        subtitle={t('Select a month to create or refresh the commission invoices due for the given period')}
                    />
                }
                {...params}
            />
        </>
    )
}

export default Generate